export const status = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  DEFAULT: 'default',
};

export const statusColorMap = {
  [status.INFO]: '#006fcf',
  [status.SUCCESS]: '#00804a',
  [status.ERROR]: '#b41601',
  [status.WARNING]: '#b5530d',
};

export const statusBgColorMap = {
  [status.SUCCESS]: '#D4EDDA',
  [status.ERROR]: '#F8D7DA',
  [status.WARNING]: '#FFF6ED',
  [status.INFO]: '#EDF7FF',
};
